import React, { useEffect, useState, useRef } from 'react';
import {
  Drawer,
  Box,
  Button,
  Typography,
  TextField,
  Switch,
  Checkbox,
  FormControlLabel,
  Chip,
  IconButton,
  CardActions,
  Alert,
  CardContent,
  InputAdornment,
  Stack
} from '@mui/material';
import {
  Done as DoneIcon,
  Error as ErrorIcon,
  AutoMode as AutoModeIcon,
} from '@mui/icons-material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ArchitectureOutlinedIcon from '@mui/icons-material/ArchitectureOutlined';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CloseIcon from '@mui/icons-material/Close';
import axios from '../../api/axios';
import DeleteIcon from '@mui/icons-material/Delete';
import RoomIcon from '@mui/icons-material/Room';
import CenterFocusWeakIcon from '@mui/icons-material/CenterFocusWeak';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Autocomplete from '@mui/material/Autocomplete';
import StickyNote2RoundedIcon from '@mui/icons-material/StickyNote2Rounded';
import CircularProgress from '@mui/material/CircularProgress';
import ContentLayout from '../ContentLayout/ContentLayout';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import { red, green } from '@mui/material/colors';

const GET_ORG = "/org/";
const GET_BUILDERS = "/builder/";
const GET_PROJECTS = "/project/";
const GET_BUILDSTAGE = "/buildstage/";
const GET_ELEVATIONS = "/elevation/";
const GET_PLANOPTIONS = "/planoption/";
const GET_PLANNUMBERS = "/plannumber/";
const CREATE_PLAN = "/plan/";
const UPLOAD_DWG_FILE = "/uploadfile/"
const SAVE_FILE = '/savefile/'
const SAVE_PDF_FILE = '/savePDF/'
const UPLOAD_PDF_FILE = "/uploadPDFfile/"

const EditPlans = ({ plan, onClose, setBuildersList, addNewPlanToBuildersList, 
  buildersList, setHighlightPlanId }) => {

  const mainFieldWidth = 552;
  const secondaryFieldWidth = 528;
  const marginTopBetweenFields = 4;

  const [orgSettings, setOrgSettings] = useState(null);

  const [planData, setPlanData] = useState(null);
  const [selectedPlanOptions, setSelectedPlanOptions] = useState([]);
  const [selectedBuildStages, setSelectedBuildStages] = useState([]);
  useEffect(() => {
    if (plan) {
      console.log("plan ", plan)
      setPlanData(plan);

      const planOptionIds = [];
      plan.options.forEach(o => planOptionIds.push(o.id));
      setSelectedPlanOptions(planOptionIds)

      const builStagesIds = [];
      plan.buildStages.forEach(o => builStagesIds.push(o.id));
      setSelectedBuildStages(builStagesIds)

      setOpenModal(true);

      const token = localStorage.getItem('token');
      
      axios.post(GET_ORG, {
        token,
        orgSettings: "true"
      })
      .then((res) => {
        const settings = res.data?.message?.settings;
        setOrgSettings(settings);
      })
      .catch((err) => {
        console.error("Error fetching org settings:", err);
      });
    }
  }, [plan]);

  const formatDateTooltip = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const [saveLoading, setSaveLoading] = useState(false);

  const [builders, setBuilders] = useState([]);
  const [builderLoading, setBuilderLoading] = useState(false);

  const [errors, setErrors] = useState({ file: '' });
  const [uploadStatus, setUploadStatus] = useState(''); // '', 'success', 'error'
  const [uploadError, setUploadError] = useState('');

  const [pdfUploadStatus, setPdfUploadStatus] = useState('');
  const [pdfUploadError, setPdfUploadError] = useState('');

  const [showValidationAlert, setShowValidationAlert] = useState(false);
  const alertRef = useRef(null);

  const [uploadLoading, setUploadLoading] = React.useState(false);
  const [planOptionLoading, setPlanOptionLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [value, setValue] = useState(null);

  const [buildStageValue, setBuildStageValue] = useState([]);
  const [buildStageLoading, setbuildStageLoading] = useState(false);
  const [buildStages, setBuildStages] = useState([]);

  const [planNumbers, setPlanNumbers] = useState([]);
  const [planLoading, setPlanLoading] = useState(false);
  const [planOptionValue, setPlanOptionValue] = useState([]);
  const [planOptions, setPlanOptions] = useState([]);

  const [elevations, setElevations] = useState([]);
  const [elevationLoading, setelevationLoading] = useState(false);

    const anchorPlacementInputRef = useRef(null);
    const lotLocationInputRef = useRef(null);

  const closeModal = () => {
    setOpenModal(false);
    setConfirmCloseDialog(false);
    setUnsavedChanges(false);
    onClose();
  };
  const [confirmCloseDialog, setConfirmCloseDialog] = useState(false);

  const [previousFile, setPreviousFile] = useState(null);
  const [previousPdfFile, setPreviousPdfFile] = useState(null);

  const hasUnsavedChanges = () => {
    if (!initialFormValues) return false;

    return Object.keys(formValues).some(key => {
      const currentValue = formValues[key];
      const initialValue = initialFormValues[key];

      if (Array.isArray(currentValue) && Array.isArray(initialValue)) {
        return JSON.stringify(currentValue) !== JSON.stringify(initialValue);
      }

      return currentValue !== initialValue;
    });
  };

  const handleAttemptClose = () => {
    if (!initialFormValues) {
      closeModal();
      return;
    }

    if (hasUnsavedChanges()) {
      setConfirmCloseDialog(true);
    } else {
      closeModal();
    }
  };

  const handleChange = (field, value) => {
    const updated = { ...formValues, [field]: value };
    const hasChanges = Object.values(updated).some(
      val =>
        val !== '' &&
        val !== null &&
        val !== false &&
        (!Array.isArray(val) || val.length > 0)
    );
    setFormValues(updated);
    setUnsavedChanges(hasChanges);
  };


  const handleDeleteFile = () => {
    setNewFile(null);
    setPreviousFile(null);
    setUploadStatus(null);
    setUploadError('');
    handleChange('file', null);
  };

  const handleDownloadPdf = async () => {
    const pdfData = previousPdfFile || newPdfFile;
    if (!pdfData) return;

    try {
      const response = await axios.post(UPLOAD_PDF_FILE, {
        token: localStorage.getItem('token'),
        downloadPdfFile: true,
        orgId: localStorage.getItem('orgId'),
        pdfId: pdfData.savedFileId,
      }, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.download = pdfData.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading PDF:', error);
    }
  };

  const [projects, setProjects] = useState([]);

  const [projectLoading, setProjectLoading] = useState(false);

  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [initialOptionIds, setInitialOptionIds] = useState([]);

  const [initialBuildStageIds, setInitialBuildStageIds] = useState([]);

  const [initialFormValues, setInitialFormValues] = useState(null)
  const [formValues, setFormValues] = useState([]);

//     useEffect(() => {
// console.log(formValues)
//   }, [formValues])

  const [newFile, setNewFile] = useState(null);
  const [newPdfFile, setNewPdfFile] = useState(null);

  const handlePdfFile = (file) => {

    const isValidSize = file.size <= 10485760;
    if (!isValidSize) {
      setErrors((prev) => ({
        ...prev,
        pdfFile: 'PDF file must be 10MB or less',
      }));
      return;
    } else {
      setErrors((prev) => ({ ...prev, pdfFile: '' }));
    }

    setPdfUploadStatus('loading');

    const modifiedDate = new Date(file.lastModified).toISOString();

    axios
      .post(SAVE_PDF_FILE, {
        token: localStorage.getItem('token'),
        savePDF: true,
        fileName: file.name,
        modifiedDate: modifiedDate,
      })
      .then((response) => {
        const savedFile = response.data?.body?.message?.pdfFile;
        if (savedFile) {
          setNewPdfFile({
            file,
            savedFileId: savedFile.id,
            name: savedFile.fileName,
            savedFileUploadedBy: savedFile.uploadedBy,
            savedFileUploadedDate: savedFile.uploadedDateAndTime,
            savedFileModifiedDate: file.lastModifiedDate
          });
          setPdfUploadStatus('success');
          handleChange('pdfFile', file);
        } else {
          console.error('Unexpected response format:', response);
          setPdfUploadStatus('error');
          setErrors((prev) => ({ ...prev, pdfFile: 'Failed to save file info' }));
        }
      })
      .catch((error) => {
        console.error('Error saving PDF file:', error);
        setPdfUploadStatus('error');
        setPdfUploadError('Error uploading file');
        setErrors((prev) => ({ ...prev, pdfFile: 'Error uploading file' }));
      });
  };

  const handleFile = (file) => {

    const isValidSize = file.size <= 5242880;
    if (!isValidSize) {
      setUploadStatus('error');
      setErrors((prev) => ({
        ...prev,
        file: 'File must be 5MB or less',
      }));
      return;
    } else {
      setUploadStatus('success');
      setUploadError('');
      setErrors((prev) => ({ ...prev, file: '' }));
    }

    const modifiedDate = new Date(file.lastModified).toISOString();
    setUploadLoading(true);

    axios
      .post(SAVE_FILE, {
        token: localStorage.getItem('token'),
        saveFile: true,
        fileName: file.name,
        modifiedDate: modifiedDate,
      })
      .then((response) => {
        const savedFile = response.data?.body?.message?.cadFile;
        if (savedFile) {
          setNewFile(({
            file,
            savedFileId: savedFile.id,
            name: savedFile.fileName,
            savedFileUploadedBy: savedFile.uploadedBy,
            savedFileUploadedDate: savedFile.uploadedDateAndTime,
            savedFileModifiedDate: file.lastModifiedDate,
            status: "processing"
          }));
          setUploadStatus('success');
          setErrors((prev) => ({ ...prev, file: '' }));
        } else {
          console.error('Unexpected response format:', response);
          setUploadStatus('error');
          setErrors((prev) => ({ ...prev, file: 'Failed to save file info' }));
        }
      })
      .catch((error) => {
        console.error('Error saving file:', error);
        setUploadStatus('error');
        setErrors((prev) => ({ ...prev, file: 'Error uploading file' }));
      })
      .finally(() => {
        setUploadLoading(false);
      });

    handleChange('file', file);
  };

  useEffect(() => {
    if (!planData) return;

    const builderId = planData.builderId;

    if (!builderId) return;

    axios.post(GET_BUILDERS, {
      token: localStorage.getItem('token'),
      getBuilders: 'true',
    })
    .then((response) => {
      let buildersList = response.data?.message?.builders || [];

      buildersList = buildersList
        .filter(b => typeof b.builderName === 'string' && (b.archived === false || b.archived === undefined))
        .sort((a, b) => {
          const nameA = a.builderName;
          const nameB = b.builderName;

          const numA = parseInt(nameA.match(/\d+/)?.[0] || "0", 10);
          const numB = parseInt(nameB.match(/\d+/)?.[0] || "0", 10);

          // First compare the non-numeric part
          const baseA = nameA.replace(/\d+/g, '').trim();
          const baseB = nameB.replace(/\d+/g, '').trim();

          if (baseA === baseB) {
            return numA - numB; // Numeric comparison
          }

          return baseA.localeCompare(baseB); // Alphabetical comparison of text prefix
        });

      setBuilders(buildersList);

      const matchedBuilder = buildersList.find(b => b.id === builderId);
      if (!matchedBuilder) {
        console.warn("⚠️ No matched builder found");
        return;
      }

      setValue(matchedBuilder);
      setInitialFormValues(prev => ({ ...prev, builder: matchedBuilder }));
      setFormValues(prev => ({ ...prev, builder: matchedBuilder }));
    })
        
  }, [planData]);

  useEffect(() => {
    const builderId = formValues.builder?.id;
    if (builderId) {

      setProjectLoading(true)
      axios.post(GET_PROJECTS, {
        token: localStorage.getItem('token'),
        getProjects: true,
        builderId
      })
      .then((res) => {
        let projectsList = res.data?.message?.projects || [];

        projectsList = projectsList
          .filter(p => typeof p.projectName === 'string' && (p.archived === false || p.archived === undefined || p.archived === "false"))
          .sort((a, b) => {
            const nameA = a.projectName;
            const nameB = b.projectName;

            const numA = parseInt(nameA.match(/\d+/)?.[0] || "0", 10);
            const numB = parseInt(nameB.match(/\d+/)?.[0] || "0", 10);

            const baseA = nameA.replace(/\d+/g, '').trim();
            const baseB = nameB.replace(/\d+/g, '').trim();

            return baseA === baseB ? numA - numB : baseA.localeCompare(baseB);
          });

        setProjects(projectsList);

        // Match the project from planData
        const matchedProject = projectsList.find(p => p.id === planData.projectId);
        if (matchedProject) {
          setInitialFormValues(prev => ({ 
            ...prev, 
            project: matchedProject.projectName, 
            projectId: matchedProject.id 
          }));
          setFormValues(prev => ({ 
            ...prev, 
            project: matchedProject.projectName, 
            projectId: matchedProject.id 
          }));
        }
      })
      .catch((err) => {
        console.error("Error fetching projects", err);
      }).finally(() => {
        setProjectLoading(false)
      })


      setPlanLoading(true);
      axios.post(GET_PLANNUMBERS, {
        token: localStorage.getItem('token'),
        getPlanNumbers: true,
        builderId
      })
      .then((res) => {
        const fetchedPlans = res.data?.message?.planNumbers || [];
        const sortedPlanNumbers = fetchedPlans
          .slice() // copy array to avoid mutating original
          .sort((a, b) =>
            a.planNumberName.localeCompare(b.planNumberName, undefined, {
              numeric: true,
              sensitivity: "base",
            })
          );

        setPlanNumbers(sortedPlanNumbers);

        // Ensure planData's planNumber is included if not in fetched list
        if (planData?.planNumber) {
          const exists = fetchedPlans.some(
            (p) => p.id === planData.planNumber.id
          );
          if (!exists) {
            setPlanNumbers((prev) => [...prev, planData.planNumber]);
          }
        }
      })
      .catch((err) => {
        console.error('Error fetching plan numbers:', err);
      })
      .finally(() => {
        setPlanLoading(false);
      });


      setelevationLoading(true);
      axios.post(GET_ELEVATIONS, {
        token: localStorage.getItem('token'),
        getElevations: true,
        builderId
      })
      .then((res) => {
        const fetchedElevations = (res.data?.message?.elevations || []).filter(e => !e.archived);
        const sorted = fetchedElevations.sort((a, b) =>
          a.elevationName.localeCompare(b.elevationName, undefined, { numeric: true, sensitivity: 'base' })
        );

        setElevations(sorted);

        for (const elev of sorted) {
          if ((elev.elevationName ?? '').toString().trim() === (formValues.elevation ?? '').toString().trim()) {
            setInitialFormValues((prev) => ({
              ...prev,
              elevationId : elev.id
            }))
            setFormValues((prev) => ({
              ...prev,
              elevationId : elev.id
            }))
            break;
          }
        }
      })
      .catch((err) => {
        console.error('Error fetching elevations:', err);
      })
      .finally(() => {
        setelevationLoading(false);
      });


      setPlanOptionLoading(true);
      axios.post(GET_PLANOPTIONS, {
        token: localStorage.getItem("token"),
        getPlanOptions: true,
        builderId
      })
      .then((res) => {
        const fetchedOptions = res.data?.message?.planOptions || [];
        const activeOptions = fetchedOptions
          .filter(opt => !opt.archived)
          .sort((a, b) =>
          a.planOptionName.localeCompare(b.planOptionName, undefined, {
            numeric: true,
              sensitivity: "base",
          })
        );

        setPlanOptions(activeOptions);

        // ✅ Hydrate the IDs into full objects after fetching
        setPlanOptionValue(
          (initialOptionIds || []).map((opt) => {
            if (typeof opt === 'object' && opt?.planOptionName) return opt;
            const match = activeOptions.find(p => p.id === opt);
            return match || null;
          }).filter(Boolean) // ✅ remove nulls
        );
      })
      .catch((err) => {
        console.error("Error fetching plan options:", err);
      })
      .finally(() => {
        setPlanOptionLoading(false);
      });
    }
  }, [formValues.builder?.id]);

  useEffect(() => {
    setbuildStageLoading(true);
      axios.post(GET_BUILDSTAGE, {
        token: localStorage.getItem('token'),
        getBuildStage: "true"
      })
      .then((res) => {
        let stages = res.data?.message.buildStages || [];

        //Sort by sortOrder ascending
        stages = stages.sort((a, b) => a.sortOrder - b.sortOrder);
        setBuildStages(stages);
      })
      .catch(err => {
        console.error("Error loading build stages:", err);
      })
      .finally(() => {
        setbuildStageLoading(false);
      });
  }, [initialBuildStageIds])

  useEffect(() => {
    const matched = (initialBuildStageIds || []).map((b) => {
      if (typeof b === 'object' && b?.buildStageName) return b;
      const match = buildStages.find(p => p.id === b);
      return match || null;
    }).filter(Boolean);

    setBuildStageValue(matched[0] ?? null);
  }, [buildStages])

  useEffect(() => {
    if (planData) {
      const newFormValues = {
        planId: planData.id,
        builder: planData.builder || null,
        project: (planData.project == "No Project Assigned" ? "" : planData.project) || "",
        projectId: (planData.project == "No Project Assigned" ? "" : planData.projectId) || "",
        lotLocation: planData.lot ?? '',
        planNumber: planData.planNumber ? { planNumberName: planData.planNumber, id: planData.planNumberId } : null,
        anchorNotes: planData.anchorNote || '',
        layout: planData.layout || '',
        elevation: planData.elevation || '',
        planNotes: planData.planNote || '',
        options: planData.options || [],
        nonStandard: planData.nonstandardAnchor || false,
        buildStage: planData.buildStages?.[0] ?? null,
        existingCadFileId: planData.cadFileId || null,
        existingFileName: planData.fileName || "",
        file: planData.cadFileId ? { savedFileId: planData.cadFileId, name: planData.fileName } : null,
        pdfFile: planData.pdfFiles ? { savedFileId: planData.pdfFiles.id, name: planData.pdfFiles.fileName } : null,
      };

      setFormValues(newFormValues);
      setInitialFormValues(newFormValues);

      setInitialOptionIds(planData.options || []);
      setInitialBuildStageIds(planData.buildStages || [])

      setPreviousFile({
        //id ??
        name: planData.fileName,
        status: planData.fileStatus,
        savedFileModifiedDate: planData.lastModifiedCadFileDateTime,
        savedFileUploadedBy: planData.uploadedCadFileBy,
        savedFileUploadedDate: planData.uploadedCadFileDateTime
      });

      if (planData.pdfFiles) {
        setPreviousPdfFile({
          savedFileId: planData.pdfFiles.id,
          name: planData.pdfFiles.fileName,
          savedFileModifiedDate: planData.pdfFiles.fileDateTime,
          savedFileUploadedBy: planData.pdfFiles.uploadedBy,
          savedFileUploadedDate: planData.pdfFiles.uploadedDateAndTime
        });
      }
    } 
  }, [planData]);

  const handleDiscardForm = () => {
    setValue(null);
    setErrors({});

    setFormValues({});
    setUnsavedChanges(false);
    setNewPdfFile(null);
    setPreviousPdfFile(null);
  };

  const handleSave = async () => {
    if (!hasUnsavedChanges()) {
      closeModal();
      return;
    }

    try {

      setUploadStatus('loading');

      const newErrors = {};

      if (!previousFile && !newFile) {
        newErrors.file = 'You must add a DWG file';
      }

      if (newFile) {
        const isDWG = newFile.name.toLowerCase().endsWith('.dwg');
        const isMax5MB = newFile.file.size <= 5242880;
        if (!isDWG) newErrors.file = 'Only .dwg files are allowed';
        else if (!isMax5MB) newErrors.file = 'File must be 5MB or less';
      }


      // Validate builder
      if (!formValues.builder) {
        newErrors.builder = 'Builder is required';
      }

      // Validate plan number
      if (!formValues.planNumber) {
        newErrors.planNumber = 'Plan # is required';
      }

      if (formValues.nonStandard && !formValues.anchorNotes?.trim()) {
        newErrors.anchorNotes = 'Anchor placement notes are required';
      }

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setShowValidationAlert(true);

        // Scroll to the alert after state updates
        setTimeout(() => {
          alertRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);

        return;
      }

      setSaveLoading(true)
      console.log("formValues before saving:", formValues);

      const planResponse = await axios.post(CREATE_PLAN, {
        token: localStorage.getItem('token'),
        updateExistingPlan: true,
        planId: formValues.planId,
        builderId: formValues.builder?.id,
        planNumberId: formValues.planNumber?.id,
        cadFileId: newFile ? newFile.savedFileId : previousFile.id || previousFile.savedFileId,
        pdfFileId: newPdfFile ? newPdfFile.savedFileId : previousPdfFile ? previousPdfFile.id || previousPdfFile?.savedFileId : "",
        projectId: formValues?.projectId || "",
        elevationId: formValues?.elevationId || "",
        planOptionIds: selectedPlanOptions,
        buildStageIds: selectedBuildStages,
        lot_Name: formValues.lotLocation || "",
        layout: formValues.layout,
        plan_Note: formValues.planNotes || "",
        nonstandard_Anchor: formValues.nonStandard,
        anchor_Note: formValues.anchorNotes || ""
      });

      const cadFile = newFile ? newFile : previousFile;

      if (newFile) {
        if(planResponse?.data?.code === 0){
          await axios.post(UPLOAD_DWG_FILE, {
            token: localStorage.getItem('token'),
            orgId: localStorage.getItem('orgId'),
            builderId: formValues.builder?.id,
            cadFile: cadFile.file,
            cadFileId: cadFile.savedFileId
          }, {
            headers: { 'Content-Type': 'multipart/form-data' }
          });
        }

        console.log("New DWG file uploaded");
      } else {
        console.log("No new file selected - keeping existing file");
      }

      const pdfFile = newPdfFile ? newPdfFile : previousPdfFile;

      // upload PDF to Azure
      if (newPdfFile) {
        await axios.post(UPLOAD_PDF_FILE, {
          token: localStorage.getItem('token'),
          pdfFile: pdfFile.file,
          pdfId: pdfFile.savedFileId
        }, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        console.log("PDF file uploaded");
      } else {
        console.log("No PDF file selected - keeping existing file");
      }

      const planOptionsForLists = planOptions.filter(o =>
        selectedPlanOptions.includes(o.id)
      );

      const buildStagesForLists = buildStages.filter(b =>
        selectedBuildStages.includes(b.id)
      );
      
      var changedBuilders = false;
      // VIEW BY PROJECTS LIST (BUILDERS AND PROJECTS EXPANDABLE)
      const newBuilders = buildersList.map(builder => {
        const updatedPlans = builder.plans.reduce((acc, plan) => {
          if (plan.id === formValues.planId) {
            if (builder.id !== formValues.builder?.id) {
              changedBuilders = true;
              return acc;
            }
            
            acc.push({
              ...plan,
              scrollId: "scroll-id-1",
              builder: formValues.builder?.name || plan.builder,
              project: formValues?.project || "No Project Assigned",
              projectId: formValues?.projectId || "",
              isArchivedProject: false,
              planNumber: formValues.planNumber?.planNumberName || plan.planNumber,
              elevation: formValues.elevation,
              layout: formValues.layout,
              options: planOptionsForLists,
              buildStages: buildStagesForLists,
              lot: formValues.lotLocation,
              planNote: formValues.planNotes,
              nonstandardAnchor: formValues.nonStandard,
              anchorNote: formValues.anchorNotes,
              fileName: cadFile.name,
              fileStatus: newFile ? 'processing' : previousFile.status,
              lastModifiedCadFileDateTime: new Date(cadFile.savedFileModifiedDate),
              uploadedCadFileDateTime: new Date(cadFile.savedFileUploadedDate),
              uploadedCadFileBy: cadFile.savedFileUploadedBy,
              planModifiedDateTime: new Date(),
              pdfFiles: newPdfFile ? {
                id: newPdfFile.savedFileId,
                fileName: newPdfFile.name,
                fileDateTime: newPdfFile.savedFileModifiedDate,
                uploadedBy: newPdfFile.savedFileUploadedBy,
                uploadedDateAndTime: newPdfFile.savedFileUploadedDate
              } : (previousPdfFile ? {
                id: previousPdfFile.id,
                fileName: previousPdfFile.name,
                fileDateTime: previousPdfFile.savedFileModifiedDate,
                uploadedBy: previousPdfFile.savedFileUploadedBy,
                uploadedDateAndTime: previousPdfFile.savedFileUploadedDate
              } : null)
            });
            return acc;
          }

          acc.push(plan);
          return acc;
        }, []);

        return { ...builder, plans: updatedPlans };
      });

      setBuildersList(newBuilders);

      if(changedBuilders) {
        await addNewPlanToBuildersList(formValues, cadFile, planOptionsForLists, buildStagesForLists, newPdfFile)
      }

      setHighlightPlanId(formValues.planId);

      setSaveLoading(false)
      closeModal();
    } catch (error) {
      console.error("Error during save:", error);
    }
  };

  // for the blue border hovering the element values using arrow keys
  const layoutListboxRef = useRef(null);
  const buildStageListboxRef = useRef(null);
  const builderListboxRef = useRef(null);
  const projectListboxRef = useRef(null);
  const planListboxRef = useRef(null);
  const elevationListboxRef = useRef(null);
  const planOptionsListboxRef = useRef(null);

  if (!planData) return <div>Loading...</div>;

  return (

    <ContentLayout title={""}>

      <Drawer

        anchor="right"
        open={openModal}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            // let handleAttemptClose decide whether to close
            handleAttemptClose();
            return;
          }
          // other reasons — close
          closeModal();
        }}

        ModalProps={{
          keepMounted: true,
          disableEscapeKeyDown: unsavedChanges,
        }}
      >
        <Box
          sx={{
            width: "670px",
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden', // Prevent body scroll bleed
          }}
        >
          <Box
            sx={{
              position: 'sticky',
              top: 0,
              zIndex: 1,
              backgroundColor: 'background.paper',
              px: 3,
              py: 2,
              borderBottom: '1px solid #eee',
            }}
          >
            <IconButton
              onClick={handleAttemptClose}
              sx={{ position: 'absolute', top: 8, right: 8 }}
            >
              <CloseIcon />
            </IconButton>

            <Typography
              variant="h6"
              sx={{ m: 0, lineHeight: 1.2 }}
            >
              Edit Plan Info
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ m: 0, mt: '4px', lineHeight: 1.4 }}
            >
              Last modified {formatDateTooltip(plan?.planModifiedDateTime)}
            </Typography>
          </Box>

          <Box
            sx={{
              flex: 1,
              overflowY: 'auto',
              px: 3,
              py: 2,
            }}
          >
            {showValidationAlert && (
              <Alert
                ref={alertRef}
                severity="error"
                sx={{
                  backgroundColor: '#fdecea',
                  color: '#611a15',
                  borderRadius: 1,
                  fontSize: '14px',
                  padding: '16px',
                  margin: '24px',
                  width: '525px'
                }}
              >
                <strong>Missing required information</strong><br />
                Please fill in the required missing information as noted.
              </Alert>
            )}

            <CardContent sx={{ ml: '8px' }}>
              {/* Upload Box */}
              <Stack direction="row" spacing={1} alignItems="center" color={"text.secondary"}>
                <ArchitectureOutlinedIcon />
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>CAD File</Typography>
              </Stack>
              <Box
                onDrop={(e) => {
                  e.preventDefault();
                  if (newFile || previousFile) return; // prevent uploading if a file exists

                  const file = e.dataTransfer.files?.[0];
                  if (!file) return;

                  if (!file.name.toLowerCase().endsWith('.dwg')) {
                    setErrors((prev) => ({
                      ...prev,
                      file: 'Unsupported file. You can only upload a .DWG',
                    }));
                    return;
                  }

                  handleFile(file);
                }}

                onDragOver={(e) => e.preventDefault()}
                onDragLeave={(e) => e.preventDefault()}
                sx={{
                  border: !newFile && !previousFile ? '2px dashed' : 'none',
                  borderColor: errors.file ? 'error.main' : 'divider',
                  borderRadius: '2px',
                  textAlign: 'center',
                  minHeight: '150px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  position: 'relative',
                  width: '552px',
                }}
              >
                {newFile ? (
                  // ✅ New file selected
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '520px',
                      height: '80px',
                      padding: '16px',
                      marginLeft: '24px',
                      marginRight: '24px',
                      border: '1px solid lightgray',
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      <UploadFileIcon
                        color={uploadStatus === 'error' ? 'error' : 'success'}
                        sx={{ mr: 1 }}
                      />
                      <Box textAlign="left">
                        <Typography variant="body2">{newFile.name}</Typography>
                        <Typography variant="caption" color="text.secondary">
                          {(newFile.file.size / 1024) >= 1024 ? `${(newFile.file.size / 1048576).toFixed(1)} MB` : `${Math.round(newFile.file.size / 1024)} KB`} • {uploadStatus === 'error' ? ' Failed' : ' Complete'}
                        </Typography>
                        {uploadStatus === 'error' && (
                          <Typography variant="caption" color="error" display="block">
                            {uploadError}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center">
                      <IconButton onClick={handleDeleteFile}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>
                ) : previousFile ? (
                  // Show file from backend
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '520px',
                      minHeight: '80px',
                      padding: '16px',
                      marginLeft: '24px',
                      marginRight: '24px',
                      border: '1px solid lightgray',
                      textAlign: "left",
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      {previousFile.status === 'processing' ? (
                        <AutoModeIcon
                          sx={{
                            mr: 1,
                            color: '#f57c00',
                            animation: 'spin 1.2s linear infinite',
                          }}
                        />
                      ) : previousFile.status === 'ready' ? (
                        <DoneIcon
                          color={'success'}
                          sx={{ mr: 1 }}
                        />
                      ) : (
                        <ErrorIcon
                          color={'error'}
                          sx={{ mr: 1 }}
                        />
                      )}
                      <Box
                          sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start"
                        }}
                      >
                        <Typography variant="body2">{previousFile.name}</Typography>
                        <Typography variant="caption" color={previousFile.status === "error" ? "error" : "text.secondary"}>
                          {previousFile.status === 'processing'
                            ? 'Processing'
                            : previousFile.status === 'error'
                              ? 'Error'
                              : 'Ready'}
                          {previousFile.savedFileModifiedDate
                            ? ` • ${new Date(previousFile.savedFileModifiedDate).toLocaleDateString("en-US", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}`
                            : ""}
                          {previousFile.savedFileUploadedDate
                            ? ` • Uploaded ${new Date(previousFile.savedFileUploadedDate).toLocaleDateString("en-US", { day: "2-digit", month: "short", year: "numeric" })}`
                            : ""}
                        </Typography>
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center">
                      <IconButton onClick={handleDeleteFile}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>
                ) : (
                  // ✅ Default: file not selected
                  <>
                    <Button
                      component="label"
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textTransform: 'none',
                        variant: 'text',
                        color: 'inherit',
                        p: 4,
                        border: '1px dashed #ccc',
                        borderRadius: 2,
                        width: '100%',
                        cursor: 'pointer',
                        textAlign: 'center',
                      }}
                    >
                      <UploadFileIcon sx={{ fontSize: 40, mb: 1, color: '#1976d2' }} />
                      <Typography>
                        <span style={{ color: '#1976d2', fontWeight: 500 }}>Link</span>
                        <span style={{ color: '#000' }}>
                          {' '}
                          or drag and drop to add or replace a file
                        </span>
                      </Typography>
                      <Typography sx={{ color: '#00000099', mt: 0.5 }}>
                        <strong>DWG</strong> (max. 5MB)
                      </Typography>
                      <input
                        type="file"
                        hidden
                        accept=".dwg"
                        onChange={(e) => {
                          if (newFile || previousFile) return;

                          const file = e.target.files[0];
                          if (!file) return;

                          if (!file.name.toLowerCase().endsWith('.dwg')) {
                            setErrors((prev) => ({
                              ...prev,
                              file: 'Unsupported file. You can only upload a .DWG',
                            }));
                            return;
                          }

                          handleFile(file);
                        }}
                      />

                    </Button>
                  </>
                )}
              </Box>

              {errors.file && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ mb: 1, display: 'block' }}
                >
                  {errors.file}
                </Typography>
              )}

              {/* PDF Upload Box */}
              <Stack direction="row" spacing={1} alignItems="center" color={"text.secondary"} sx={{ mt: 2 }}>
                <DescriptionOutlinedIcon />
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>Plan PDF</Typography>
              </Stack>
              <Box
                onDrop={(e) => {
                  e.preventDefault();
                  if (newPdfFile || previousPdfFile) return;

                  const file = e.dataTransfer.files?.[0];
                  if (!file) return;

                  if (!file.name.toLowerCase().endsWith(".pdf")) {
                    setErrors((prev) => ({
                      ...prev,
                      pdfFile: "Unsupported file. You can only upload a .PDF",
                    }));
                    return;
                  }

                  handlePdfFile(file);
                }}
                onDragOver={(e) => e.preventDefault()}
                onDragLeave={(e) => e.preventDefault()}
                sx={{
                  border: !newPdfFile && !previousPdfFile ? "2px dashed" : "none",
                  borderColor: errors.pdfFile ? "error.main" : "divider",
                  borderRadius: "2px",
                  textAlign: "center",
                  mb: "2px",
                  mt: 2,
                  minHeight: "150px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  position: "relative",
                  width: "552px",
                }}
                data-testid="pdf-upload-area"
              >
                  {newPdfFile ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "520px",
                      height: "80px",
                      padding: "16px",
                      marginLeft: "24px",
                      marginRight: "24px",
                      borderBottom: "1px solid lightgray",
                      textAlign: "left",
                    }}
                    data-testid="pdf-file-preview"
                  >
                    <Box display="flex" alignItems="center">
                      <UploadFileIcon
                        color={pdfUploadStatus === 'error' ? 'error' : 'success'}
                        sx={{ mr: 1 }}
                        data-testid="pdf-preview-icon"
                      />
                      <Box>
                        <Typography variant="body2" data-testid="pdf-file-name" sx={{ textAlign: "left !important" }}>
                          {newPdfFile.file.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ textAlign: "left" }}>
                          <span data-testid="pdf-file-size">
                            {(newPdfFile.file.size / 1024) >= 1024 ? `${(newPdfFile.file.size / 1048576).toFixed(1)} MB` : `${Math.round(newPdfFile.file.size / 1024)} KB`} • {pdfUploadStatus === 'error' ? ' Failed' : ' Complete'}
                          </span>
                        </Typography>
                        {pdfUploadStatus === 'error' && (
                          <Typography variant="caption" color="error" display="block">
                            {pdfUploadError}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center">
                      <IconButton
                        onClick={() => {
                          setNewPdfFile(null);
                          setPdfUploadStatus('');
                          setPdfUploadError('');
                          setErrors((prev) => ({ ...prev, pdfFile: '' }));
                          handleChange('pdfFile', null);
                        }}
                        data-testid="delete-pdf-button"
                      >
                        <DeleteIcon fontSize="small" data-testid="pdf-delete-icon" />
                      </IconButton>
                    </Box>
                  </Box>
                ) : previousPdfFile ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "520px",
                      height: "80px",
                      padding: "16px",
                      marginLeft: "24px",
                      marginRight: "24px",
                      border: "1px solid lightgray",
                    }}
                    data-testid="pdf-file-existing"
                  >
                    <Box display="flex" alignItems="center">
                      <PictureAsPdfIcon sx={{ mr: 1, color: "#1976d2" }} />
                      <Box>
                        <Typography
                          variant="body2"
                          sx={{ cursor: "pointer", color: "#1976d2", textDecoration: "underline", textAlign: "left" }}
                          onClick={handleDownloadPdf}
                        >
                          {previousPdfFile.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {previousPdfFile.savedFileModifiedDate
                            ? `${new Date(previousPdfFile.savedFileModifiedDate).toLocaleDateString("en-US", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}`
                            : ""}
                          {previousPdfFile.savedFileUploadedDate
                            ? ` • Uploaded ${new Date(previousPdfFile.savedFileUploadedDate).toLocaleDateString("en-US", { day: "2-digit", month: "short", year: "numeric" })}`
                            : ""}
                        </Typography>
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center">
                      <IconButton
                        onClick={() => {
                          setPreviousPdfFile(null);
                          setNewPdfFile(null);
                          setErrors((prev) => ({ ...prev, pdfFile: '' }));
                          handleChange('pdfFile', null);
                        }}
                        data-testid="delete-pdf-button"
                      >
                        <DeleteIcon fontSize="small" data-testid="pdf-delete-icon" />
                      </IconButton>
                    </Box>
                  </Box>
                ) : (
                  <>
                    <Button
                      component="label"
                      startIcon={null}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textTransform: "none",
                        variant: "text",
                        color: "inherit",
                        p: 4,
                        border: "1px dashed #ccc",
                        borderRadius: 2,
                        width: "100%",
                        cursor: "pointer",
                  textAlign: !newPdfFile && !previousPdfFile ? "center" : "left",
                      }}
                      data-testid="pdf-upload-button"
                    >
                      <UploadFileIcon
                        sx={{ fontSize: 40, mb: 1, color: "#1976d2" }}
                        data-testid="pdf-upload-icon"
                      />
                      <Typography data-testid="pdf-upload-text">
                        <span style={{ color: "#1976d2", fontWeight: 500 }}>
                          Link
                        </span>
                        <span style={{ color: "#000" }}>
                          {" "}
                          or drag and drop to add a PDF plan sheet
                        </span>
                      </Typography>
                      <Typography
                        sx={{ color: "#00000099", mt: 0.5 }}
                        data-testid="pdf-text"
                      >
                        <strong>PDF</strong> (max. 10MB)
                      </Typography>
                      <input
                        type="file"
                        hidden
                        accept=".pdf"
                        onChange={(e) => {
                          if (newPdfFile?.file || previousPdfFile) return;

                          const file = e.target.files[0];
                          if (!file) return;

                          if (!file.name.toLowerCase().endsWith(".pdf")) {
                            setErrors((prev) => ({
                              ...prev,
                              pdfFile: "Unsupported file. You can only upload a .PDF",
                            }));
                            return;
                          }

                          handlePdfFile(file);
                        }}
                        data-testid="pdf-file-input"
                      />
                    </Button>
                  </>
                )}
              </Box>

              {errors.pdfFile && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ mb: 1, display: "block" }}
                >
                  {errors.pdfFile}
                </Typography>
              )}

              <FormControlLabel
                sx={{ mt: marginTopBetweenFields, ml: 2 }}
                control={
                  <Switch
                    checked={formValues.nonStandard}
                    onChange={(e) => {
                      handleChange('nonStandard', e.target.checked)
                      if(e.target.checked){
                        setTimeout(() => {
                          anchorPlacementInputRef.current?.focus();
                        }, 100);
                      }
                    }}
                    disabled={!formValues.builder}
                  />
                }
                label="Non-standard Anchor Placement (Optional)"
              />

              {formValues.nonStandard ? (
                <Box sx={{ mt: marginTopBetweenFields, ml: 3 }}>
                  <Box display="flex" alignItems="center">
                    <TextField
                      sx={{ width: secondaryFieldWidth }}
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">
                              <CenterFocusWeakIcon sx={{ color: red[500] }}/>
                            </InputAdornment>
                          ),
                        },
                      }}
                      data-testid="anchor-placement-input"
                      fullWidth
                      id="input-with-sx"
                      label="Non-standard Anchor Placement Notes"
                      inputRef={anchorPlacementInputRef}
                      variant="standard"
                      inputProps={{ maxLength: 500 }}
                      value={formValues.anchorNotes}
                      onChange={(e) =>
                        handleChange("anchorNotes", e.target.value)
                      }
                      error={!!errors.anchorNotes}
                      helperText={errors.anchorNotes}
                    />
                  </Box>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                  >
                    Help crews know where to place anchor images. 
                  </Typography>
                </Box>
              ) : (
                <Box display="flex" alignItems="center" sx={{ mt: marginTopBetweenFields, ml: 3 }}>
                  <CenterFocusStrongIcon sx={{ color: green[500], mr: 1 }} />
        
                  <Box>
                    <Box display="flex" alignItems="center">
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 0.5 }}>
                          Standard Anchor Placement
                        </Typography>
                        <Typography variant="body2">
                          {formValues?.nonStandard
                            ? formValues.anchorNotes || 'No anchor note provided.'
                            : orgSettings?.standard_anchor_placement || 'Standard placement not defined'}
                        </Typography>
                      </Box>
                    </Box>
                    <Typography
                      variant="caption"
                      color="textSecondary"
                    >
                      (Admins can adjust this standard in Settings)
                    </Typography>
                  </Box>
                </Box>
              )}

              <Autocomplete
                sx={{ mt: marginTopBetweenFields, ml: 3, width: secondaryFieldWidth }}
                value={buildStageValue}
                autoHighlight
                openOnFocus
                id="build-stage-autocomplete"
                options={buildStages}
                componentsProps={{
                  paper: {
                    sx: {
                      '& .MuiAutocomplete-option[aria-selected="true"]': {
                        backgroundColor: '#1976d214 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                        backgroundColor: '#1976d229 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option.Mui-focused': {
                        backgroundColor: '#0000000a !important',
                        fontWeight: 'normal',
                      },
                      // Only when keyboard-nav class is present
                      '& .keyboard-nav .MuiAutocomplete-option.Mui-focused': {
                        outline: '2px solid #1976d2 !important',
                        outlineOffset: '-2px',
                      },
                    },
                  },
                }}
                onKeyDown={() => buildStageListboxRef.current?.classList.add('keyboard-nav')}
                ListboxProps={{
                  ref: buildStageListboxRef,
                  onMouseMove: () => buildStageListboxRef.current?.classList.remove('keyboard-nav'),
                }}
                isOptionEqualToValue={(option, value) => {
                    if (!option || !value) return false;
                    if (option.id && value.id) return option.id === value.id;
                    return (
                      (option.buildStageName || "").trim().toLowerCase() ===
                      (value.buildStageName || "").trim().toLowerCase()
                    );
                  }}
                getOptionLabel={(option) => {
                  if (typeof option === "string") return option;
                  if (option?.inputValue) return option.inputValue;
                  return option?.buildStageName || "";
                }}
                filterOptions={(options, params) => {
                  const filtered = options.filter((option) =>
                    option.buildStageName.toLowerCase().includes(params.inputValue.toLowerCase())
                  );

                  return filtered;
                }}
                onChange={(event, newValue) => {
                  const selectedBuildStagesIds = [];

                  if (newValue) {
                    selectedBuildStagesIds.push(newValue?.id);
                  }

                  setBuildStageValue(newValue);
                  setSelectedBuildStages(selectedBuildStagesIds);

                  setFormValues((prev) => ({
                    ...prev,
                    buildStage: newValue
                  }));
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                freeSolo
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  const isAddOption = !!option.inputValue;
                  return (
                    <li key={key} {...optionProps} style={{ color: isAddOption ? '#1976d2' : 'inherit' }}>
                      {option.buildStageName}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Build Stage (Optional)"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {buildStageLoading ? <CircularProgress color="inherit" size={20} /> : null}
                          {buildStageValue ? params.InputProps.endAdornment : null}
                        </>
                      ),
                    }}
                  />
                )}
              />

              <Autocomplete
                sx={{ mt: marginTopBetweenFields, width: mainFieldWidth }}
                value={value}
                autoHighlight
                componentsProps={{
                  paper: {
                    sx: {
                      '& .MuiAutocomplete-option[aria-selected="true"]': {
                        backgroundColor: '#1976d214 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                        backgroundColor: '#1976d229 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option.Mui-focused': {
                        backgroundColor: '#0000000a !important',
                        fontWeight: 'normal',
                      },
                      // Only when keyboard-nav class is present
                      '& .keyboard-nav .MuiAutocomplete-option.Mui-focused': {
                        outline: '2px solid #1976d2 !important',
                        outlineOffset: '-2px',
                      },
                    },
                  },
                }}
                onKeyDown={() => builderListboxRef.current?.classList.add('keyboard-nav')}
                ListboxProps={{
                  ref: builderListboxRef,
                  onMouseMove: () => builderListboxRef.current?.classList.remove('keyboard-nav'),
                }}
                onChange={async (event, newValue) => {
                  const input = typeof newValue === 'string' ? newValue : newValue?.inputValue;
                
                  // Typed or "Add new" builder
                  if (typeof newValue === 'string' || (newValue && newValue.inputValue)) {
                    const trimmedInput = input?.trim().toLowerCase();
                    const exists = builders.some(
                      (b) => b.builderName.trim().toLowerCase() === trimmedInput
                    );

                    if (exists) {
                      
                      const existingBuilder = builders.find(
                        (b) => b.builderName.trim().toLowerCase() === trimmedInput
                      );
                      
                      setValue(existingBuilder);
                      setFormValues((prev) => ({ ...prev, 
                        builder: existingBuilder, 
                        project: null,
                        projectId: "",
                        planNumber: "",
                        elevation: "",
                        elevationId: "",
                        layout: '',
                        option: [],
                        options: [],
                      }));
                      setErrors((prev) => ({ ...prev, builder: '' }));
                      setProjects([]);
                      setElevations([]);
                      setPlanNumbers(null);
                      setPlanOptionValue([]);
                      setInitialOptionIds([]);
                      setSelectedPlanOptions([]);

                    } else if (input) {
                      setBuilderLoading(true);
                      try {
                        const response = await axios.post(GET_BUILDERS, {
                          token: localStorage.getItem('token'),
                          createBuilder: 'true',
                          builderName: input,
                        });

                        const newBuilder = response.data?.message?.builder;

                        if(response.data.code == 223){
                          let existingId = response.data.existingBuilderId

                            axios.post(GET_BUILDERS, {
                                token: localStorage.getItem('token'),
                                archiveBuilder: true,
                                archive: false,
                                id: existingId
                            })
                            .then((response) => {
                              console.log(response)

                              const builder = {
                                builderName: input,
                                id: existingId,
                                orgId: localStorage.getItem("orgId")
                              }
                              
                              setBuilders((prev) => [...prev, builder]);
                              setValue(builder);
                              setFormValues((prev) => ({
                                ...prev,
                                builder: builder,
                                project: null, 
                                projectId: "",
                                planNumber: "",
                                elevation: "",
                                elevationId: "",
                                layout: '',
                                option: [],
                                options: [],
                              }));
                              setErrors((prev) => ({ ...prev, builder: "" }));

                              setElevations([]);
                              setPlanNumbers(null);
                              setPlanOptionValue([]);
                              setInitialOptionIds([]);
                              setSelectedPlanOptions([]);

                            })
                            .catch((error) => {
                                console.error('Error updating builder archive status:', error);
                            });

                        } else {

                          setBuilders((prev) => [...prev, newBuilder]);
                          setValue(newBuilder);
                          setFormValues((prev) => ({ ...prev, 
                            builder: newBuilder, 
                            project: null, 
                            planNumber: "",
                            elevation: "",
                            elevationId: "",
                            layout: '',
                            option: [],
                            options: [],
                          }));
                          setErrors((prev) => ({ ...prev, builder: '' }));
                          setProjects([]);
                          setElevations([]);
                          setPlanNumbers(null);
                          setPlanOptionValue([]);
                          setInitialOptionIds([]);
                          setSelectedPlanOptions([]);
                        }
                      } catch (error) {
                        console.error('Error creating builder:', error);
                      } finally {
                        setBuilderLoading(false);
                      }
                    }
                  } else {
                    // Selected from dropdown
                    setValue(newValue);
                    setFormValues((prev) => ({ 
                      ...prev, 
                      builder: newValue, 
                      project: null, 
                      projectId: "",
                      planNumber: "",
                      elevation: "",
                      elevationId: "",
                      layout: '',
                      option: [],
                      options: [],
                    }));
                    setProjects([]);

                    setElevations([]);
                    setPlanNumbers(null);
                    setPlanOptionValue([]);
                    setInitialOptionIds([]);
                    setSelectedPlanOptions([]);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = options.filter((option) =>
                    option.builderName.toLowerCase().includes(params.inputValue.toLowerCase())
                  );
                  const isExisting = options.some(
                    (option) => option.builderName.toLowerCase() === params.inputValue.toLowerCase()
                  );
                  if (params.inputValue !== '' && !isExisting) {
                    filtered.push({
                      inputValue: params.inputValue,
                      builderName: `Add "${params.inputValue}"`,
                    });
                  }
                  return filtered;
                }}
                id="builder-autocomplete"
                options={builders}
                getOptionLabel={(option) =>
                  typeof option === 'string' ? option : option.inputValue || option.builderName
                }
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                freeSolo
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  const isAddOption = !!option.inputValue;
                  return (
                    <li key={key} {...optionProps}>
                      <span style={{ color: isAddOption ? '#1976d2' : 'inherit' }}>
                        {option.builderName}
                      </span>
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Builder Name"
                    error={Boolean(errors.builder)}
                    helperText={errors.builder}
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 50, // ✅ enforce 50 characters
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {builderLoading && <CircularProgress color="inherit" size={20} />}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />

              <Autocomplete
                sx={{ mt: marginTopBetweenFields, ml: 3, width: secondaryFieldWidth }}
                disabled={!formValues.builder}
                value={projects.find(p => p.id === formValues.projectId) ?? null}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  if (option.id && value.id) return option.id === value.id;
                  return option.projectName?.trim().toLowerCase() === value.projectName?.trim().toLowerCase();
                }}
                autoHighlight
                openOnFocus
                onChange={(event, newValue) => {

                  setFormValues(prev => ({
                    ...prev,
                    project: newValue?.projectName || "",
                    projectId: newValue?.id || ""
                  }));
                  const input = typeof newValue === 'string' ? newValue : newValue?.inputValue;

                  const builderId = formValues.builder?.id;

                  if (!builderId) {
                    console.warn("No builder ID found; skipping project fetch.");
                    return;
                  }

                  if (typeof newValue === 'string' || (newValue && newValue.inputValue)) {
                    const trimmedInput = input?.trim().toLowerCase();
                    const exists = projects.some(
                      (p) => p.projectName.trim().toLowerCase() === trimmedInput
                    );

                    if (exists) {
                      const existingProject = projects.find(
                        (p) => p.projectName.trim().toLowerCase() === trimmedInput
                      );
                      setFormValues((prev) => ({
                        ...prev, 
                        project: existingProject.projectName,
                        projectId: existingProject?.id || ""
                      }));

                    } else if (input) {
                      // New project, create it
                      setProjectLoading(true);

                      axios.post(GET_PROJECTS, {
                        token: localStorage.getItem('token'),
                        addProject: 'true',
                        builderId,
                        projectName: input,
                      })
                        .then((response) => {
                          const newProject = response.data?.message?.project;

                          if(response.data.code == 224){
                            let existingId = response.data.existingProjectId

                              axios.post(GET_PROJECTS, {
                                  token: localStorage.getItem('token'),
                                  builderId: builderId,
                                  archiveProject: true,
                                  archive: false,
                                  id: existingId
                              })
                              .then((response) => {
                                console.log(response)

                                const newProject = {
                                  projectName: input,
                                  id: existingId,
                                  orgId: localStorage.getItem("orgId")
                                }
                                
                                setProjects((prev) => {
                                  const exists = prev.some(
                                    (p) =>
                                      p.projectName.trim().toLowerCase() ===
                                      newProject.projectName.trim().toLowerCase()
                                  );
                                  if (!exists) {
                                    return [...prev, newProject];
                                  }
                                  return prev;
                                });

                                setFormValues((prev) => ({
                                  ...prev,
                                  project: newProject.projectName,
                                  projectId: newProject.id
                                }));

                              })
                              .catch((error) => {
                                  console.error('Error updating builder archive status:', error);
                              });

                          } else {

                            setProjects((prev) => {
                              const exists = prev.some(
                                (p) =>
                                  p.projectName.trim().toLowerCase() ===
                                  newProject.projectName.trim().toLowerCase()
                              );
                              if (!exists) {
                                return [...prev, newProject];
                              }
                              return prev;
                            });

                            setFormValues((prev) => ({
                              ...prev,
                              project: newProject.projectName,
                              projectId: newProject.id
                            }));
                          }
                        })
                        .catch((error) => {
                          console.error('Error creating project:', error);
                        })
                        .finally(() => {
                          setProjectLoading(false);
                        });
                    }
                  } else {
                    // Selected from dropdown
                    setFormValues((prev) => ({
                      ...prev,
                      project: newValue?.projectName || "",
                      projectId: newValue?.id || "",
                    }));
                  }
                }}

                filterOptions={(options, params) => {
                  const filtered = options.filter((option) =>
                    option.projectName.toLowerCase().includes(params.inputValue.toLowerCase())
                  );

                  const inputValue = params.inputValue.trim().toLowerCase();
                  const exactMatch = options.some(
                    (option) => option.projectName.trim().toLowerCase() === inputValue
                  );

                  if (params.inputValue !== '' && !exactMatch) {
                    filtered.push({
                      inputValue: params.inputValue,
                      projectName: `Add "${params.inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                componentsProps={{
                  paper: {
                    sx: {
                      '& .MuiAutocomplete-option[aria-selected="true"]': {
                        backgroundColor: '#1976d214 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                        backgroundColor: '#1976d229 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option.Mui-focused': {
                        backgroundColor: '#0000000a !important',
                        fontWeight: 'normal',
                      },
                      // Only when keyboard-nav class is present
                      '& .keyboard-nav .MuiAutocomplete-option.Mui-focused': {
                        outline: '2px solid #1976d2 !important',
                        outlineOffset: '-2px',
                      },
                    },
                  },
                }}
                onKeyDown={() => projectListboxRef.current?.classList.add('keyboard-nav')}
                ListboxProps={{
                  ref: projectListboxRef,
                  onMouseMove: () => projectListboxRef.current?.classList.remove('keyboard-nav'),
                }}
                id="project-autocomplete"
                options={projects}
                getOptionLabel={(option) => {
                  if (typeof option === 'string') {
                    return option;
                  }
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  return option.projectName;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                freeSolo
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  const isAddOption = !!option.inputValue;

                  return (
                    <li key={key} {...optionProps}>
                      <span style={{ color: isAddOption ? '#1976d2' : 'inherit' }}>
                        {option.projectName}
                      </span>
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Project Name (Optional)"
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 50,
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {projectLoading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
              
              <Box sx={{ mt: marginTopBetweenFields, ml: 3, width: secondaryFieldWidth }}>
                <Box display="flex" alignItems="center">
                  <TextField id="input-with-sx" label="Lot Location" variant="standard"
                    disabled={!formValues.builder} // Disable until builder is selected
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <RoomIcon/>
                          </InputAdornment>
                        ),
                      },
                    }}
                    fullWidth
                    value={formValues.lotLocation}
                    onChange={(e) => handleChange('lotLocation', e.target.value)}
                    inputRef={lotLocationInputRef}
                    error={!!errors.lotLocation}
                    helperText={errors.lotLocation}
                    inputProps={{ maxLength: 5 }}
                  />
                </Box>
                <Typography variant="caption" color="textSecondary">
                  Where is the lot located? (Lot number, address, etc.)
                </Typography>
              </Box>
              


              <Autocomplete
                sx={{ mt: marginTopBetweenFields, width: mainFieldWidth }}
                disabled={!formValues.builder}
                value={
                  planNumbers?.find(p => 
                    p.id === formValues.planNumber?.id ||
                    p.planNumberName === formValues.planNumber ||
                    p.planNumberName === formValues.planNumber?.planNumberName
                  ) ?? null
                }
                autoHighlight
                openOnFocus
                componentsProps={{
                  paper: {
                    sx: {
                      '& .MuiAutocomplete-option[aria-selected="true"]': {
                        backgroundColor: '#1976d214 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                        backgroundColor: '#1976d229 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option.Mui-focused': {
                        backgroundColor: '#0000000a !important',
                        fontWeight: 'normal',
                      },
                      // Only when keyboard-nav class is present
                      '& .keyboard-nav .MuiAutocomplete-option.Mui-focused': {
                        outline: '2px solid #1976d2 !important',
                        outlineOffset: '-2px',
                      },
                    },
                  },
                }}
                onKeyDown={() => planListboxRef.current?.classList.add('keyboard-nav')}
                ListboxProps={{
                  ref: planListboxRef,
                  onMouseMove: () => planListboxRef.current?.classList.remove('keyboard-nav'),
                }}

                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  if (option.id && value.id) return option.id === value.id;
                  return option.planNumberName?.trim().toLowerCase() === value.planNumberName?.trim().toLowerCase();
                }}
                onChange={(event, newValue) => {
                  const input = (typeof newValue === 'string' ? newValue : newValue?.inputValue) || '';
                  const builderId = formValues?.builder?.id;

                  if (!builderId) {
                    console.error("Cannot add plan: builder ID is missing.");
                    return;
                  }

                  if (newValue === null) {
                    // User clicked X → just clear the selected plan number
                    setFormValues((prev) => ({ ...prev, planNumber: null }));
                    return;
                  }

                  if (typeof newValue === 'string' || (newValue && newValue.inputValue)) {
                    const trimmedInput = input.trim().toLowerCase();
                    const exists = planNumbers.some(
                      (p) => (p?.planNumberName || '').trim().toLowerCase() === trimmedInput
                    );

                    if (exists) {
                      const existingPlan = planNumbers.find(
                        (p) => (p?.planNumberName || '').trim().toLowerCase() === trimmedInput
                      );
                      
                      setFormValues((prev) => ({
                        ...prev,
                        planNumber: existingPlan,
                      }));
                      setErrors((prev) => ({ ...prev, planNumber: '' }));

                    } else if (input) {

                      setPlanLoading(true);

                      axios.post(GET_PLANNUMBERS, {
                        token: localStorage.getItem('token'),
                        createPlanNumber: true,
                        planNumberName: input,
                        builderId: builderId
                      })
                        .then((response) => {
                          const newPlan = response.data?.message?.plannumber;

                          if(response.data.code === 225){ // unarchive, if exists
                            let existingId = response.data.existingPlanNumberId
                            axios.post(GET_PLANNUMBERS, {
                                token: localStorage.getItem('token'),
                                archivePlanNumber: true,
                                archive: false,
                                id: existingId,
                                builderId: builderId
                            })
                            .then((response) => {
                              console.log(response)
                              console.log(planNumbers)
                              
                              setPlanNumbers((prev) => [
                                ...prev,
                                {
                                  planNumberName: input,
                                  id: existingId,
                                  orgId: localStorage.getItem("orgId"),
                                },
                              ]);

                              setFormValues((prev) => ({
                                ...prev,
                                planNumber: {
                                  planNumberName: input,
                                  id: existingId,
                                  orgId: localStorage.getItem("orgId"),
                                },
                              }));

                            })
                            .catch((error) => {
                                console.error('Error updating builder archive status:', error);
                            });

                          } else{ // add if not exists

                            if (!newPlan || !newPlan.planNumberName) {
                              console.error("Invalid plan format from server:", response.data);
                              return;
                            }
                              
                            setPlanNumbers((prev) => {
                              const exists = prev.some(
                                (p) =>
                                  p?.planNumberName?.trim().toLowerCase() ===
                                  newPlan.planNumberName.trim().toLowerCase()
                              );
                              return exists ? prev : [...prev, newPlan];
                            });

                            
                            setFormValues((prev) => ({
                              ...prev,
                              planNumber: newPlan,
                            }));
                            setErrors((prev) => ({ ...prev, planNumber: '' }));
                          }

                        })
                        .catch((error) => {
                          console.error('Error creating plan number:', error);
                        })
                        .finally(() => {
                          setPlanLoading(false);
                        });
                    }
                  } else {
                    // Existing plan selected from dropdown
                    
                    setFormValues((prev) => ({
                      ...prev,
                      planNumber: newValue,
                    }));

                    if (newValue?.planNumberName) {
                      setErrors((prev) => ({ ...prev, planNumber: '' }));
                    }
                  }
                }}

                filterOptions={(options, params) => {
                  const filtered = options?.filter((option) =>
                    option?.planNumberName?.toLowerCase().includes(params.inputValue.toLowerCase())
                  );

                  const inputValue = params.inputValue.trim().toLowerCase();
                  const exactMatch = options?.some(
                    (option) => (option?.planNumberName || '').trim().toLowerCase() === inputValue
                  );

                  if (params.inputValue !== '' && !exactMatch) {
                    filtered.push({
                      inputValue: params.inputValue,
                      planNumberName: `Add "${params.inputValue}"`,
                    });
                  }

                  return filtered;
                }}

                id="plan-autocomplete"
                options={planNumbers}
                getOptionLabel={(option) => {
                  if (typeof option === 'string') return option;
                  if (option.inputValue) return option.planNumberName;
                  return option.planNumberName;
                }}

                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                freeSolo
                loading={planLoading}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  const isAddOption = !!option.inputValue;

                  return (
                    <li key={key} {...optionProps}>
                      <span style={{ color: isAddOption ? '#1976d2' : 'inherit' }}>
                        {option.planNumberName}
                      </span>
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Plan #"
                    error={Boolean(errors.planNumber)}
                    helperText={errors.planNumber}
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 15,
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {planLoading ? <CircularProgress color="inherit" size={20} sx={{ mr: 2 }} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />

              {/* Add the Typography component below Autocomplete */}
              <Typography variant="caption" color="textSecondary">
                This is the identifier the plan was assigned by the builder.
              </Typography>


              <Autocomplete
                sx={{ mt: marginTopBetweenFields, ml: 3, width: secondaryFieldWidth }}
                disabled={!formValues.builder}
                autoHighlight
                openOnFocus
                value={elevations.find(e =>
                  e.id === formValues.elevationId ||
                  e.elevationName === formValues.elevation
                ) ?? null}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  if (option.id && value.id) return option.id === value.id;
                  return option.elevationName?.trim().toLowerCase() === value.elevationName?.trim().toLowerCase();
                }}
                componentsProps={{
                  paper: {
                    sx: {
                      '& .MuiAutocomplete-option[aria-selected="true"]': {
                        backgroundColor: '#1976d214 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                        backgroundColor: '#1976d229 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option.Mui-focused': {
                        backgroundColor: '#0000000a !important',
                        fontWeight: 'normal',
                      },
                      // Only when keyboard-nav class is present
                      '& .keyboard-nav .MuiAutocomplete-option.Mui-focused': {
                        outline: '2px solid #1976d2 !important',
                        outlineOffset: '-2px',
                      },
                    },
                  },
                }}
                onKeyDown={() => elevationListboxRef.current?.classList.add('keyboard-nav')}
                ListboxProps={{
                  ref: elevationListboxRef,
                  onMouseMove: () => elevationListboxRef.current?.classList.remove('keyboard-nav'),
                }}
                onChange={(event, newValue) => {
                  setFormValues(prev => ({
                    ...prev,
                    elevationId: newValue?.id || "",
                    elevation: newValue?.elevationName || ""
                  }));

                  const input = typeof newValue === 'string' ? newValue : newValue?.inputValue;
                  const builderId = formValues?.builder?.id;

                  if (!builderId) {
                    console.error("Cannot add elevation: builder ID is missing.");
                    return;
                  }

                  const trimmedInput = input?.trim().toLowerCase();
                  const exists = elevations.some(
                    (e) => (e?.elevationName || '').trim().toLowerCase() === trimmedInput
                  );

                  if (exists) {
                    const existingElevation = elevations.find(
                      (e) => (e?.elevationName || '').trim().toLowerCase() === trimmedInput
                    );
                    setFormValues((prev) => ({
                      ...prev,
                      elevation: existingElevation.elevationName,
                      elevationId: existingElevation.id
                    }));

                  } else if (input) {
                    setelevationLoading(true);

                    axios.post(GET_ELEVATIONS, {
                      token: localStorage.getItem('token'),
                      addElevation: 'true',
                      builderId,
                      elevationName: input,
                    })
                      .then((response) => {
                        const newElevation = response.data?.message?.elevation;

                        if (response.data.code === 224) { // unarchive, if exists
                          let existingId = response.data.elevationId
                          axios.post(GET_ELEVATIONS, {
                            token: localStorage.getItem('token'),
                            archiveElevation: true,
                            archive: false,
                            id: existingId,
                            builderId: builderId
                          })
                            .then((response) => {
                              console.log(response)

                              setElevations((prev) => [
                                ...prev,
                                {
                                  elevationName: input,
                                  id: existingId,
                                  orgId: localStorage.getItem("orgId"),
                                },
                              ]);

                              setFormValues((prev) => ({
                                ...prev,
                                elevation: input,
                                elevationId: existingId
                              }));

                            })
                            .catch((error) => {
                              console.error('Error updating builder archive status:', error);
                            });

                        } else { // add if not exists

                          if (!newElevation || !newElevation.elevationName) {
                            console.error('newElevation or elevationName missing:', newElevation);
                            return;
                          }

                          setElevations((prev) => [
                            ...prev,
                            {
                              elevationName: newElevation.elevationName,
                              id: newElevation.id,
                              orgId: localStorage.getItem("orgId"),
                            },
                          ]);

                          setFormValues((prev) => ({
                            ...prev,
                            elevation: newElevation.elevationName,
                            elevationId: newElevation.id
                          }));
                        }
                      })
                      .catch((error) => {
                        console.error('Error creating elevation:', error);
                      })
                      .finally(() => {
                        setelevationLoading(false);
                      });
                    }
                }}


                filterOptions={(options, params) => {
                  const filtered = options.filter((option) =>
                    option?.elevationName?.toLowerCase()?.includes(params.inputValue.toLowerCase())
                  );

                  const inputValue = params.inputValue.trim().toLowerCase();
                  const exactMatch = options.some(
                    (option) => option?.elevationName?.trim().toLowerCase() === inputValue
                  );

                  if (params.inputValue !== '' && !exactMatch) {
                    filtered.push({
                      inputValue: params.inputValue,
                      elevationName: `Add "${params.inputValue}"`,
                    });
                  }

                  return filtered;
                }}

                options={elevations}
                getOptionLabel={(option) => {
                  if (typeof option === 'string') return option;
                  if (option.inputValue) return option.inputValue;
                  return option.elevationName;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                freeSolo
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  const isAddOption = !!option.inputValue;

                  return (
                    <li key={key} {...optionProps}>
                      <span style={{ color: isAddOption ? '#1976d2' : 'inherit' }}>
                        {option.elevationName}
                      </span>
                    </li>
                  );
                }}

                renderInput={(params) => (
                  <TextField
                    {...params}
                    value={formValues.elevation || null}
                    variant="standard"
                    label="Elevation (Optional)"
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 5,
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {elevationLoading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />

              <Autocomplete
                sx={{ mt: marginTopBetweenFields, ml: 3, width: secondaryFieldWidth }}
                disabled={!formValues.builder}
                value={formValues.layout || null}
                autoHighlight
                openOnFocus
                onKeyDown={() => layoutListboxRef.current?.classList.add('keyboard-nav')}
                ListboxProps={{
                  ref: layoutListboxRef,
                  onMouseMove: () => layoutListboxRef.current?.classList.remove('keyboard-nav'),
                }}
                componentsProps={{
                  paper: {
                    sx: {
                      '& .MuiAutocomplete-option[aria-selected="true"]': {
                        backgroundColor: '#1976d214 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                        backgroundColor: '#1976d229 !important',
                        fontWeight: 'bold',
                      },
                      '& .MuiAutocomplete-option.Mui-focused': {
                        backgroundColor: '#0000000a !important',
                        fontWeight: 'normal',
                      },
                      // Only when keyboard-nav class is present
                      '& .keyboard-nav .MuiAutocomplete-option.Mui-focused': {
                        outline: '2px solid #1976d2 !important',
                        outlineOffset: '-2px',
                      },
                    },
                  },
                }}
                onChange={(event, newValue) => {
                  setFormValues((prev) => ({
                    ...prev,
                    layout: newValue || '',
                  }));
                }}
                options={['Left', 'Right']}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                popupIcon={null}
                clearIcon={<CloseIcon fontSize="small" />}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Layout (Optional)"
                  />
                )}
              />

              <Box 
                sx={{ mt: marginTopBetweenFields, ml: 3, width: secondaryFieldWidth }} 
                variant="standard"
              >
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  disabled={!formValues.builder}
                  freeSolo
                  selectOnFocus
                  autoHighlight
                  openOnFocus
                  clearOnBlur={false}
                  componentsProps={{
                    paper: {
                      sx: {
                        '& .MuiAutocomplete-option[aria-selected="true"]': {
                          backgroundColor: '#1976d214 !important',
                          fontWeight: 'bold',
                        },
                        '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                          backgroundColor: '#1976d229 !important',
                          fontWeight: 'bold',
                        },
                        '& .MuiAutocomplete-option.Mui-focused': {
                          backgroundColor: '#0000000a !important',
                          fontWeight: 'normal',
                        },
                        // Only when keyboard-nav class is present
                        '& .keyboard-nav .MuiAutocomplete-option.Mui-focused': {
                          outline: '2px solid #1976d2 !important',
                          outlineOffset: '-2px',
                        },
                      },
                    },
                  }}
                  onKeyDown={() => planOptionsListboxRef.current?.classList.add('keyboard-nav')}
                  ListboxProps={{
                    ref: planOptionsListboxRef,
                    onMouseMove: () => planOptionsListboxRef.current?.classList.remove('keyboard-nav'),
                  }}
                  handleHomeEndKeys
                  options={planOptions}
                  value={planOptionValue}
                  isOptionEqualToValue={(option, value) => {
                    if (!option || !value) return false;
                    if (option.id && value.id) return option.id === value.id;
                    return (
                      (option.planOptionName || "").trim().toLowerCase() ===
                      (value.planOptionName || "").trim().toLowerCase()
                    );
                  }}
                  getOptionLabel={(option) => {
                    if (typeof option === "string") return option;
                    if (option.inputValue) return option.inputValue;
                    return option.planOptionName;
                  }}
                  filterOptions={(options, params) => {
                    const filtered = options.filter((option) =>
                      option.planOptionName.toLowerCase().includes(params.inputValue.toLowerCase())
                    );

                    const isExisting = options.some(
                      (option) =>
                        option.planOptionName.toLowerCase() === params.inputValue.toLowerCase()
                    );

                    if (params.inputValue !== "" && !isExisting) {
                      filtered.push({
                        inputValue: params.inputValue,
                        planOptionName: `Add "${params.inputValue}"`,
                      });
                    }

                    return filtered;
                  }}
                  onChange={async (event, newValue) => {
                    const builderId = formValues.builder?.id;
                    if (!builderId) return;

                    const selectedOptionIds = [];
                    const selectedOptionNames = [];
                    const finalValue = [];

                    // Utility: check if already added to finalValue
                    const isAlreadyInFinal = (name) =>
                      finalValue.some(
                        (opt) => opt.planOptionName.trim().toLowerCase() === name.trim().toLowerCase()
                      );

                    for (const item of newValue) {
                      const input = typeof item === "string" ? item : item?.inputValue;

                      if (typeof item === "string" || item?.inputValue) {
                        const trimmed = input.trim().toLowerCase();

                        // Check if it exists in planOptions (including archived)
                        const exists = planOptions.find(
                          (opt) => opt.planOptionName.trim().toLowerCase() === trimmed
                        );

                        if (exists) {
                          // Skip if already added to finalValue
                          if (!isAlreadyInFinal(exists.planOptionName)) {
                            selectedOptionIds.push(exists.id);
                            selectedOptionNames.push(exists.planOptionName);
                            finalValue.push(exists);
                          }
                        } else {
                          // Create new option in DB
                          try {
                            setPlanOptionLoading(true);
                            const response = await axios.post(GET_PLANOPTIONS, {
                              token: localStorage.getItem("token"),
                              createPlanOption: true,
                              builderId,
                              planOptionName: input,
                            });

                            console.log(response.data)

                            if(response.data.code === 227){ // unarchive, if exists
                              let existingId = response.data.existingPlanOptionId
                              axios.post(GET_PLANOPTIONS, {
                                  token: localStorage.getItem('token'),
                                  archivePlanOption: true,
                                  archive: false,
                                  id: existingId,
                                  builderId: builderId
                              })
                              .then((response) => {
                                console.log(response)
                                
                                var planOption = {
                                    planOptionName: input,
                                    id: existingId,
                                    builderId: builderId,
                                    orgId: localStorage.getItem("orgId"),
                                  }
                                setPlanOptions(prev => [
                                  ...prev, 
                                  planOption
                                ]);
                                selectedOptionIds.push(existingId);
                                selectedOptionNames.push(input);
                                finalValue.push(planOption);

                              })
                              .catch((error) => {
                                  console.error('Error updating builder archive status:', error);
                              });

                            } else { // add new, if not exist
                              const newOpt = response.data?.message?.planoption;

                              if (newOpt && !isAlreadyInFinal(newOpt.planOptionName)) {
                                setPlanOptions(prev => [...prev, newOpt]);
                                selectedOptionIds.push(newOpt.id);
                                selectedOptionNames.push(newOpt.planOptionName);
                                finalValue.push(newOpt);
                              }
                            }
                            setPlanOptionLoading(false);
                          } catch (err) {
                            console.error("Error adding option:", err);
                          }
                        }
                      } else {
                        // Normal option object selected from list
                        if (!isAlreadyInFinal(item.planOptionName)) {
                          selectedOptionIds.push(item.id);
                          selectedOptionNames.push(item.planOptionName);
                          finalValue.push(item);
                        }
                      }
                    }

                    setSelectedPlanOptions(selectedOptionIds);
                    setFormValues((prev) => ({
                      ...prev,
                      option: selectedOptionNames,
                    }));
                    setPlanOptionValue(finalValue);
                  }}

                  renderTags={(selected, getTagProps) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((option, index) => {
                        const tagProps = getTagProps({ index });
                        const { key, ...otherProps } = tagProps;

                        return (
                          <Chip
                            key={key ?? option.id ?? option.planOptionName ?? index}
                            variant="outlined"
                            label={option.planOptionName}
                            {...otherProps}
                            sx={{
                              backgroundColor: "#424242",
                              color: "#fff",
                              ".MuiChip-deleteIcon": {
                                color: "#ccc",
                                "&:hover": { color: "#fff" },
                              },
                            }}
                          />
                        );
                      })}
                    </Box>
                  )}

                  renderOption={(props, option, { selected }) => {
                    const { key, ...otherProps } = props;
                    return (
                      <li key={key} {...otherProps}>
                        <Checkbox
                          style={{ marginRight: 8 }}
                          checked={planOptionValue.some(
                            (opt) => opt.planOptionName === option.planOptionName
                          )}
                        />
                        <span style={{ color: option.inputValue ? '#1976d2' : 'inherit' }}>
                          {option.planOptionName}
                        </span>
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label="Plan Options (Optional)"
                      placeholder="Select or add options"
                      inputProps={{
                        ...params.inputProps,
                        maxLength: 40,
                      }}
                      InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {planOptionLoading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                    />
                  )}
                  sx={{ width: "100%" }}
                />

                <Typography variant="caption" color="textSecondary">
                  Options help you identify the different options or variations used in the plan.
                </Typography>
              </Box>

              

              <Box sx={{ mt: marginTopBetweenFields, ml: 3, width: secondaryFieldWidth }}>
                <Box display="flex" alignItems="center">
                  <TextField
                    data-testid="plan-notes-input"
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <StickyNote2RoundedIcon/>
                          </InputAdornment>
                        ),
                      },
                    }}
                    disabled={!formValues.builder}
                    fullWidth
                    label="Plan Notes (Optional)"
                    variant="standard"
                    inputProps={{ maxLength: 500 }}
                    value={formValues.planNotes || ''}
                    onChange={(e) =>
                      setFormValues((prev) => ({
                        ...prev,
                        planNotes: e.target.value,
                      }))
                    }
                  />
                </Box>
                <Typography variant="caption" color="textSecondary">
                  Notes that will help the team in the field.
                </Typography>
              </Box>
              

            </CardContent>
          </Box>
          <CardActions
            sx={{
              position: 'sticky',
              bottom: 0,
              backgroundColor: 'background.paper',
              display: 'flex',
              width: '552px',
              padding: '24px',
              borderTop: '1px solid #eee',
            }}
          >
            <Button size="medium" variant="contained" onClick={handleSave} loading={saveLoading} loadingPosition="start">
              Save Plan
            </Button>

            <Button variant="text" color="black" sx={{ display: "none" }}>
              Remove Plan
            </Button>
          </CardActions>
        </Box>
      </Drawer>

      <Dialog
        open={confirmCloseDialog}
        onClose={(event, reason) => {
          // Treat both backdrop click and ESC as Cancel
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            setConfirmCloseDialog(false); // Only close dialog, no discarding
          }
        }}
      >
        <DialogTitle>Discard Plan Info?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You have unsaved changes. If you close now, these changes will be discarded.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmCloseDialog(false)}>Cancel</Button>
          <Button
            onClick={() => {
              handleDiscardForm();
              closeModal();
              setConfirmCloseDialog(false);
            }}
            color="error"
          >
            Discard Plan Info
          </Button>
        </DialogActions>
      </Dialog>

    </ContentLayout>
  );


};

export default EditPlans;
